import { gql } from 'apollo-angular';

export const CREATE_PROPERTY = gql`
  mutation createProperty($createPropertyInput: CreatePropertyInput!) {
    createProperty(createPropertyInput: $createPropertyInput) {
      id
      branchId
      propertyName
      address
      annualRent
      vacancies
      status
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_PROPERTY = gql`
  mutation updateProperty(
    $id: Int!
    $updatePropertyInput: CreatePropertyInput!
  ) {
    updateProperty(id: $id, updatePropertyInput: $updatePropertyInput) {
      id
      branchId
      propertyName
      address
      annualRent
      vacancies
      status
      createdAt
      updatedAt
    }
  }
`;

export const REMOVE_PROPERTY = gql`
  mutation removeProperty($id: Int!) {
    removeProperty(id: $id)
  }
`;

export const ALLOCATE_EMPLOYEE = gql`
  mutation allocateEmployeeToProperty(
    $createEmployeeWithPropertyInput: CreateEmployeeWithPropertyInput!
  ) {
    allocateEmployeeToProperty(
      createEmployeeWithPropertyInput: $createEmployeeWithPropertyInput
    ) {
      id
      propertyId
      employeeId
      isActive
      startDate
      endDate
      daysOccupied
      status
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_ALLOCATE_EMPLOYEE = gql`
  mutation updateEmployeeAllocation(
    $updateEmployeeWithPropertyInput: UpdateEmployeeWithPropertyInput!
  ) {
    updateEmployeeAllocation(
      updateEmployeeWithPropertyInput: $updateEmployeeWithPropertyInput
    ) {
      id
      propertyId
      employeeId
      isActive
      startDate
      endDate
      daysOccupied
      status
      createdAt
      updatedAt
    }
  }
`;
